export default function setSobrenome(nome) {
    const texto = nome.split(' ');
    texto.shift();
    const response = texto.join(' ');
    response.substring(0, response.length - 1);
    return response;
  }